<template>
  <v-text-field
    v-model="likePattern"
    clearable
    @keyup.enter="applyFiltersAndGetItems"
    label="Patrón LIKE para la marca"
    prepend-icon="check"
  />
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapMutations, mapState } = createNamespacedHelpers(
  "classifier"
);

export default {
  computed: {
    ...mapState(["likePatternBrandFilter"]),
    likePattern: {
      set(pattern) {
        this.setLikePatternBrandFilter(pattern);
      },
      get() {
        return this.likePatternBrandFilter;
      }
    }
  },
  methods: {
    ...mapMutations(["setLikePatternBrandFilter"]),
    ...mapActions(["applyFiltersAndGetItems"])
  }
};
</script>